import { ConfigProvider } from 'antd'
import { observer } from 'mobx-react-lite'
import { useRoutes, RouteObject } from 'react-router-dom'
import './App.css'
import './index.css'
import { Suspense, useEffect, useRef } from 'react'
import routes from './router'
import { useStore } from './store'
import { CoRouteObject } from './types/route.d'
import { runInAction } from 'mobx'
import { authService } from "./services/auth";
import { deepClone } from './utils/json'
import { Toast } from './components/Toast';

const App = observer(() => {
    const { UserStore, MenuStore, ConfigStore } = useStore()
    const isAuthenticated = authService.isAuthenticated()
  const routesRef = useRef<RouteObject[]>(routes as RouteObject[])

  useEffect(() => {
    if (isAuthenticated) {
      const filteredRoutes = UserStore.filterRoutesByRoles(deepClone(routes))
      const rootRoute = filteredRoutes.find(route => route.root) as CoRouteObject

      runInAction(() => {
        UserStore.setAllRoutes(filteredRoutes)
        MenuStore.initRoutesAndMenu(rootRoute)
      })

      routesRef.current = filteredRoutes as RouteObject[]
    } else {
      routesRef.current = routes as RouteObject[]
    }
  }, [isAuthenticated])
    return (
        <ConfigProvider theme={ConfigStore.themeConfig}>
            {/* <PageProgress /> */}
            <Toast />
            <Suspense>
                {useRoutes(routesRef.current as RouteObject[])}
            </Suspense>
        </ConfigProvider>
    )
})

export default App
